import React from 'react';
interface LoadingSpinnerProps {
  message?: string;
}
export function LoadingSpinner({
  message = 'Cargando...'
}: LoadingSpinnerProps) {
  return <div className="w-full min-h-screen bg-white flex items-center justify-center px-8 py-24" data-id="element-149">
      <div className="flex flex-col items-center gap-8" data-id="element-150">
        {/* Animated squares */}
        <div className="relative w-24 h-24" data-id="element-151">
          {/* Outer rotating square */}
          <div className="absolute inset-0 border-4 border-purple animate-spin-slow" style={{
          animationDuration: '3s'
        }} data-id="element-152" />

          {/* Middle rotating square */}
          <div className="absolute inset-3 border-4 border-yellow animate-spin-reverse" style={{
          animationDuration: '2s'
        }} data-id="element-153" />

          {/* Inner pulsing square */}
          <div className="absolute inset-6 bg-purple animate-pulse" data-id="element-154" />
        </div>

        {/* Loading text */}
        <div className="bg-yellow border-brutal border-[#1A1A1A] rounded-none shadow-brutal px-12 py-6" data-id="element-155">
          <span className="font-display text-2xl text-purple uppercase tracking-wide font-bold" data-id="element-156">
            {message}
          </span>
        </div>
      </div>
    </div>;
}